/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './FullWidthTemplate.style';

import MainTopBar from 'src/shared/app/base/component/maintopbar/MainTopBar';
import MobileNavBar from 'src/shared/app/base/component/mobilenavbar/MobileNavBar';
import TakeOverPortal from 'src/shared/app/notification/component/TakeOverPortal';
import Container from 'src/shared/app/base/component/container/Container';
import NotificationPortal from 'src/shared/app/notification/component/NotificationPortal';

const useStyles = createUseThemeStyles(styles);

type Props = {
  contentMaxWidth?: number,
  Switch: React.ComponentType<any>,
};

const FullWidthNavTemplate = ({
  contentMaxWidth,
  Switch,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ contentMaxWidth });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <MainTopBar />

      <div className={classes.takeOverContainer}>
        <NotificationPortal />
        <TakeOverPortal />
      </div>

      <div className={classes.content}>
        <Container className={classes.container}>
          <div className={classes.contentInner}>
            <Switch layoutClass={classes.main} />
          </div>
        </Container>
      </div>

      <MobileNavBar />
    </div>
  );
};

export default React.memo<Props>(FullWidthNavTemplate);
